module.exports = __webpack_public_path__ + "img/page-header-fact sheets.jpg";